import React from 'react';
import {
  SelectField,
} from '@unite-us/ui';

export function init(Survey, isCreator) {
  const widget = {
    name: 'dropdown-multiselect',
    title: 'Dropdown Multiselect',
    isFit: (question) => question.getType() === 'dropdown-multiselect',
    isDefaultRender: isCreator,
    iconName: 'icon-dropdown',
    defaultJSON: {
      choices: ["Item 1", "Item 2", "Item 3"],
    },
    widgetIsLoaded: () => true,
    activatedByChanged: () => {
      Survey.JsonObject.metaData.addClass('dropdown-multiselect', [], null, 'checkbox');
    },
    render: (question) => (
      <SelectField
        id={`select-${question.name}`}
        label=""
        options={question.getChoices().map((c) => ({ id: c.value, label: c.text }))}
        valueKey="id"
        shouldSort={false}
        multiple
        maxSelectedChoices={question.propertyHash?.maxSelectedChoices}
        value={question.value}
        searchThreshold={0.4}
        onChange={(selectedOption) => {
          question.setValueCore(selectedOption.map((e) => e.id));
        }}
      />
    ),
  };

  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
}

